export const VACATION_RENTAL_PLANS = {
    NO_PLAN:      0,
    FREE_PLAN:    3,
    PREMIUM_PLAN: 4,
} as const;
